import { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { getGroupHashKey } from "@containers/entities/helpers";

const useGetDefaultUpfCourseId = () => {
  const classrooms = useSelector(state => state.entitiesReducer.classrooms);
  const groups = useSelector(state => state.entitiesReducer.groups);
  const selectedClass = useSelector(state => state.UPFAssignReducer.selectedClass, shallowEqual);
  const selectedGroup = useSelector(state => state.UPFAssignReducer.selectedGroup, shallowEqual);

  return useMemo(() => {
    const groupKey = getGroupHashKey({ classroomId: selectedClass?.value, groupId: selectedGroup?.value });
    return groups[groupKey]?.defaultUpfCourseId || classrooms[selectedClass?.value]?.defaultUpfCourseId;
  }, [classrooms, groups, selectedClass?.value, selectedGroup?.value]);
}

export default useGetDefaultUpfCourseId;


// WEBPACK FOOTER //
// ./helpers/hooks/use-get-default-upf-course-id.js